import Button from '@components/designSystem/Button'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import { useAuthConfiguration } from '@state/signInClients.ts'

function SignOutButton() {
  const { t } = useTypedTranslation()
  const { data } = useAuthConfiguration()
  return <Button size='lg' href={data?.signOutUrl} target='_self'>{t('account.logout')}</Button>
}

export default SignOutButton